//Module Keys

let locales = {
    vidfleet_search_by_esn: "Buscar por esn",
    vidfleet_last: "Último",
    vidfleet_range: "Rango",
    vidfleet_apply: "Aplicar",
    vidfleet_warning_time: "Tiempo de advertencia",
    vidfleet_camera_sm: "ESN de la Cámara",
    vidfleet_warning: "Advertencia",
    vidfleet_maintenance_warnings: "Advertencias de VidFleet",
    vidfleet_maintenance_warnings_details: "Detalles",
    vidfleet_maintenance_warnings_view_details: "Ver Detalles",
    vidfleet_events: "Eventos",
    vidfleet_the_esn_could_not_be_consulted: "El esn no pudo ser consultado",
    vidfleet_the_esn_does_not_exist: "El esn no existe",
    vidfleet_error_maintenance_warnings: "No se ha obtenido ningún aviso de mantenimiento debido a un error",
    vidfleet_uploaded_time: "Tiempo de carga",
    vidfleet_request_time: "Fecha de Solicitud",
    vidfleet_description: "Descripción",
    vidfleet_error_camera_logs: "No se ha obtenido ningún registro de la cámara debido a un error",
    vidfleet_camera_logs: "Registros de la cámara",
    vidfleet_previous_status: "Estado anterior",
    vidfleet_current_status: "Estado actual",
    vidfleet_change_time: "Hora del cambio",
    vidfleet_error_dms_statuses: "No se ha obtenido ningún estado DMS debido a un error",
    vidfleet_dms_statuses: "Estados del DMS",
    vidfleet_created_time: "Tiempo de Creación",
    vidfleet_power_off_time: "Tiempo de Desconexión",
    vidfleet_recover_time: "Tiempo de Recuperación",
    vidfleet_error_power_lost: "No se ha obtenido ninguna pérdida de potencia debido a un error",
    vidfleet_power_lost: "Pérdida de Potencia",
    vidfleet_change_time: "Tiempo de cambio",
    vidfleet_error_sd_card_status: "No se ha obtenido el estado de la tarjeta sd debido a un error",
    vidfleet_sd_card_status: "Estado de la Tarjeta SD",
    vidfleet_account: "Cuenta",
    vidfleet_device_name: "Nombre del dispositivo",
    vidfleet_device_model: "Modelo de dispositivo",
    apply_lang: "Aplicar",
    vidfleet_created_at: "Creado en",
    vidfleet_white_listed_devices_error: "No se ha obtenido ningún dispositivo de la lista blanca debido a un error",
    vidfleet_white_listed_devices: "Dispositivos listados en blanco",
    vidfleet_show_vidfleet_info: "Mostrar información de Vidfleet",
    vidfleet_warning_type: "Tipo de advertencia",
    vidfleet_warning_account: "Cuenta",
    vidfleet_warning_liked_unit: "Dispositivo Emparejado",
    vidfleet_warning_liked_unit_name: "Nombre Dispositivo Emparejado",
    vidfleet_warning_model: "Modelo de la Cámara",
    vidfleet_maintenance: "Mantenimiento",
    vidfleet_user: "Usuario",
    apply: "Aplicar",
    Apply_lang: "Aplicar",
    vidfleet_warning: "Advertencias",
    vidfleet_reason: "Motivo",
    vidfleet_poweredBy : "Accionado Por",
    vidfleet_lastGpsData : "Últimos Datos Gps",
    vidfleet_firmwares_reviews: "Firmwares",
};

//Merge Views
import vidFleetConfiguration from 'Modules/vidfleet/.components/configuration/lan/es';
import restrictionsModal from 'Modules/vidfleet/.components/restrictionsModal/lan/es';
import cloneSettingsModal from 'Modules/vidfleet/.components/cloneSettingsModal/lan/es';
import vidFleetConfigurationUploadMode from 'Modules/vidfleet/.components/configurationUploadMode/lan/es';
import showChangesHistory from 'Modules/vidfleet/.components/showChangesHistory/lan/es';
import vidFleetConfigurationHubSpot from 'Modules/vidfleet/.components/configurationHubSpot/lan/es';
import configurationPreview from 'Modules/vidfleet/.components/configurationPreview/lan/es'

locales = { ...locales, ...vidFleetConfiguration, ...restrictionsModal, ...cloneSettingsModal, ...vidFleetConfigurationUploadMode, ...showChangesHistory, ...vidFleetConfigurationHubSpot, ...configurationPreview };

export default locales;